<template>
    <div class="content">
        <h2>重大案件法制审核表</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="140px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="日期:" prop="riqi">
                        <el-date-picker size="small"
                            v-model="form.riqi"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="拟作出行政执法决定名称:" prop="jdmc">
                        <el-input v-model="form.jdmc" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="拟作出行政执法决定的简要事实:" prop="jyss">
                        <el-input v-model="form.jyss" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="相关证据目录:" prop="xgzj">
                        <el-input v-model="form.xgzj" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="所涉法律条款:" prop="fltk">
                        <el-input v-model="form.fltk" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="submit('form')">生成重大案件法制审核表</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="重大案件法制审核表" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['code','pcId','anyou','wfss','zhengju','falv'],
    data() {
        return {
            loading:false,
            xm:'',
            sj1:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
                jdmc:'',
                jyss:'',
                xgzj:'',
                fltk:'',
                riqi:'',
                zbr:'',
                xbr:'',
                fzr:'',
                shr:'',
                yj:'',
                lxr:'',
                sj1:''
            },
            rules:{
                riqi:[
                    { required: true, message: '日期不能为空', trigger: ['change','blur'] }
                ],
            },
            isWs:false,
            type:1,
            mid:'',
            lsh:'',

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[]
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.sj1 = user.sj1
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw

        this.$set(this.form,'jdmc',this.anyou)
        this.$set(this.form,'jyss',this.wfss)
        this.$set(this.form,'xgzj',this.zhengju)
        this.$set(this.form,'fltk',this.falv)
        this.getList()
    },
    methods: {
        async getList(){
            this.getZfxx()
            this.isWs = false
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getshenheshuju&pcId=${this.pcId}`)
            console.log(data.data)
            if(data.data){
                if(data.data[0]){
                    //有
                    this.isWs = true
                    this.$set(this.form,'riqi',data.data[0].rq)
                    this.$set(this.form,'jdmc',data.data[0].mc)
                    this.$set(this.form,'jyss',data.data[0].ss)
                    this.$set(this.form,'xgzj',data.data[0].ml)
                    this.$set(this.form,'fltk',data.data[0].fl)
                    // this.$set(this.form,'zbr',data.data[0].host_man)
                    // this.$set(this.form,'xbr',data.data[0].xiebanren)
                    // this.$set(this.form,'fzr',data.data[0].jingyingzhexm)
                }
            }
        },
        async getZfxx(){
            this.mid = ''
            this.lsh = ''
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=fazhishenhebiao&sjs='+new Date().getTime()
                let nm = 'fazhishenhebiao'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                    
                this.mid = data.data[0].dwmc_id
                this.lsh = data.data[0].lsh
                this.$set(this.form,'zbr',data.data[0].host_man)
                this.$set(this.form,'xbr',data.data[0].xiebanren)
                this.$set(this.form,'fzr',data.data[0].jingyingzhexm)
                // let yj = data.data[0].jinggao+(Number(data.data[0].fakuan) > 0 ? '罚款'+ data.data[0].fakuan : '')
                // this.$set(this.form,'yj',yj)
                // this.$set(this.form,'sj1',data.data[0].xiebanren)
            }
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    axios({
                            method: 'post',
                            url: `${this.Global._baseUrl2}`,
                            data: {
                                act: "shengchengshenhe",//"getFazhishenhe_rq",
                                id: `${this.pcId}`,
                                lsh: `${this.lsh}`,
                                mid: `${this.mid}`,
                                rq:`${this.getDate(this.form.riqi,'yyyy-MM-dd')}`,
                                mc:`${escape(this.form.jdmc)}`,
                                ss:`${escape(this.form.jyss)}`,
                                ml:`${escape(this.form.xgzj)}`,
                                fl:`${escape(this.form.fltk)}`,
                                shi:`${escape(this.shi)}`,
                                xianqu:`${escape(this.xianqu)}`,
                                jingbanren:`${escape(this.form.zbr)}`,
                                xiebanren:`${escape(this.form.xbr)}`,
                                fuzeren:`${escape(this.form.fzr)}`,
                                shenheren:`${escape(this.xm)}`,
                                yj:`${escape('警告')}`,
                                lxr:`${escape(this.xm)}`,
                                sj1:`${escape(this.sj1)}`,
                            },
                            transformRequest: [function (data) {
                                data = qs.stringify(data);
                                return data;
                            }],
                            headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                        }).then(res => {
                            console.log(res)
                            // if(res.data == 1){
                            //     this.$message({
                            //         message: '保存成功',
                            //         type: 'error'
                            //     });
                            //     console.log(res.data.code)
                            //     // this.type = 0
                            //     // this.getList()
                            //     this.loading = false
                            // }else{
                                
                            //     this.$message({
                            //         message: '保存失败，请重新填写',
                            //         type: 'error'
                            //     });
                            // }
                            this.loading = false
                            if(res.data.code != -1){
                                console.log(res.data.code)
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.isWs = true
                                // this.wsUrl = res.data.data.split('?')[1]
                                this.wsUrl = 'mid='+this.mid+'&lsh='+this.lsh+'&wsnameEw=fazhishenhebiao&sjs='+new Date().getTime()
                                console.log(this.wsUrl,this.mid,this.lsh)
                                this.show()
                            }else{
                                if(res.data.data){
                                    this.$message.error(res.data.data)
                                }else{
                                    this.$message({
                                        message: '保存失败，请重新填写',
                                        type: 'error'
                                    }); 
                                }
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                }
            })
        },
        show(){
            // let url = this.wsUrl
            // window.open(url,'_blank')
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'fazhishenhebiao.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.mid}&lsh=${this.lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-textarea.is-disabled .el-textarea__inner { color: #333;}
</style>